
import api from '../libs/api';

export default {
	getEquipments: (page = 1, itemsPerPage = 15) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/equipments`, {
					params: {
						page: page,
						per_page: itemsPerPage,
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getEquipmentsUP: async (page = 1, itemsPerPage = 15, searchQuery = '') => {
		try {
			const { status, data } = await api().get(`/equipments`, {
				params: { page, per_page: itemsPerPage, search: searchQuery },
			});
			if (status === 200) return data;
			throw new Error(`Failed with status: ${status}`, status);
		} catch (error) {
			throw error;
		}
	},

	getAllEquipments: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-all-equipments`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postEquipment: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/equipments`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateEquipment: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/equipments/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteEquipment: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/equipments/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getPriceHistory: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/equipments/${id}/price-history`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
